<lx-price-lists-portal-school-header
  [company]="school?.schoolLanguage === 'English' ? CompanyEnum.KIL : CompanyEnum.ALP"
  [country]="group?.country"
  [school]="school?.schoolName"
>
  <!--
    The <ng-template #customPriceListLinks> block below is a projected template.
    It allows the parent component (aya-school-header) to provide a custom price list links component
    to the lx-price-lists-portal-school-header. If this template is present, the school-header will render it
    using ngTemplateOutlet. If not present, the school-header will render its default price list links.
    This pattern enables flexible content projection and conditional rendering of default or custom content
    according to Angular best practices.
  -->
  <ng-template #customPriceListLinks>
    <lx-price-lists-portal-price-aya-list-links
      [company]="school?.schoolLanguage === 'English' ? CompanyEnum.KIL : CompanyEnum.ALP"
      [schoolLanguage]="school?.schoolLanguage"
      [countryCode]="group?.country?.code"
      [supplements]="school?.supplements"
      [programDates]="school?.programDates"
      [sessionBreaks]="school?.sessionBreaks"
    ></lx-price-lists-portal-price-aya-list-links>
  </ng-template>
</lx-price-lists-portal-school-header>
